<template>
  <svg fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M6 3.75C5.17125 3.75 4.5 4.42125 4.5 5.25V12.75C4.5 13.5787 5.17125 14.25 6 14.25C6.82875 14.25 7.5 13.5787 7.5 12.75V5.25C7.5 4.42125 6.82875 3.75 6 3.75ZM12 3.75C11.1712 3.75 10.5 4.42125 10.5 5.25V12.75C10.5 13.5787 11.1712 14.25 12 14.25C12.8287 14.25 13.5 13.5787 13.5 12.75V5.25C13.5 4.42125 12.8287 3.75 12 3.75Z"
      fill="currentColor"></path>
  </svg>
</template>
